import type { ListingMyListings } from "@/types/listing";

/** Seller must act only once admin has requested a BankID signature on an uploaded contract. */
export const sellerContractNeedsSignature = (
  listing: Pick<ListingMyListings, "sellerContract">,
): boolean =>
  listing.sellerContract?.signatureStatus === "requested" &&
  Boolean(listing.sellerContract?.document);
